module.exports = "/assets/6b99fe8abac2bb64f1b3a6eddf0c6168.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KA.png
// module id = 2662
// module chunks = 0